import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";

import ContextComponent from "../../AppContext";
import Utils from "../../Utils";
import DefaultQRCode from "./../../../assets/img/qrcode.png";

const QRCode = (props) => {
  let cardId = props.cardId;
  let card = props.cardInfo;
  let floatClassNames = card.rtl ? "indi-float-right" : "indi-float-left";
  let { userData, addrCtxData } = useContext(ContextComponent);

  const [cardInfo, setCardInfo] = useState(card);
  const [templateInfo, setTemplateInfo] = useState(card.templateInfo);
  
  const [mobiles, setMobiles] = useState([]);
  const [email, setEmail] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [qrCode, setQrCode] = useState(DefaultQRCode);

  const [canRender, setCanRender] = useState(false);
  let [mobileImg, setMobileImg] = useState("");
  let [emailImg, setEmailImg] = useState("");
  let [addressImg, setAddressImg] = useState("");
  let [hasJoint, setHasJoint] = useState(false);
  let [showAddress, setShowAddress] = useState(false);

  let [salutation, setSalutation] = useState("");
  const success = (res) => {
    let mobileNumbers = [];
    let email = "";
    let address = "";
    let canShowAddress = res?.data?.templateInfo?.includeAddress ?? false;
    let userLinkedBadges = res.data?.userLinkedBadges || [];
    userLinkedBadges.map((badge, index) => {
      if (badge.badgeUID === "phone") {
        let mobileValue = badge.value || badge.defaultValue || "";
        if (mobileValue.length) {
          mobileNumbers.push(mobileValue);
        }
        setMobileImg(badge.iconImage);
      }
      if (badge.badgeUID === "email") {
        email = badge.value || badge.defaultValue || "";
        if (badge.constant) {
          email = badge.defaultValue || badge.value || "";
        }
        setEmailImg(badge.iconImage);
      }
      if (canShowAddress && badge.badgeUID === "address") {
        address = badge.value || badge.defaultValue || "";
        if (badge.constant) {
          address = badge.defaultValue || badge.value || "";
        }
        setAddressImg(badge.iconImage);
        // console.log(parseInt(badge.value, 10));
        address = addrCtxData.fullAddresses[parseInt(badge.value, 10)];

        let currentId = parseInt(badge.value, 10);
        let currentIndex = addrCtxData.ids.indexOf(currentId);
        let currentAddressName = addrCtxData["addressNames"][currentIndex];
        let currentAddress = addrCtxData["addresses"][currentIndex];
        let currentFullAddress =
          addrCtxData["fullAddresses"][currentIndex] ?? "";
        address = currentFullAddress;
        // console.log(currentFullAddress);
      }
    });
    setFullAddress(address);
    setShowAddress(canShowAddress);
    setMobiles(mobileNumbers);
    setEmail(email);
    setQrCode(res.data.qrCode || DefaultQRCode);
    setCardInfo(res.data);
    if(res.data?.userFieldInfo?.salutation?.length) {
      let sal = res.data?.userFieldInfo?.salutation.replace(".", "");
      sal = Utils.SALUTATION[sal] ?? sal;
      setSalutation(sal + " ");
    }
  };

  const fail = (err) => {
    err?.message?.length && console.log(err);
  };

  useEffect(() => {
    if (Utils.isObjectEmpty(card)) {
      Utils.getCardDetails(cardId).then(success, fail);
    } else {
      success({
        data: card,
      });
    }
  }, [card, cardId, cardInfo]);

  const defColor = "#232862";

  let [imgBackgroundColor, setImgBackgroundColor] = useState(defColor);
  let [jointImgBackgroundColor, setJointImgBackgroundColor] =
    useState(defColor);

  let classNames = [
    hasJoint ? "indi-logo-img-wrapper-container" : "",
    `indi-qrcode-logo-images-wrapper`,
  ].join(" ");

  let logoImageClasses = ["indi-logo-image qqq", "indi-joint-logo-image"].join(" ");

  useEffect(() => {}, [
    fullAddress,
    mobiles,
    email,
    qrCode,
    showAddress,
    jointImgBackgroundColor,
  ]);
  
  const templateSuccess = (res) => {
    setTemplateInfo(res.data);
    setImgBackgroundColor(
      !!res.data?.logoBGColor ? res.data?.logoBGColor : defColor,
    );
    setJointImgBackgroundColor(
      !!res.data?.jointLogoBGColor ? res.data?.jointLogoBGColor : defColor,
    );
    if (res.data?.jointLogoImage) {
      setJointImgBackgroundColor(res.data?.jointLogoBGColor);
      setHasJoint(true);
    } else {
      setJointImgBackgroundColor("");
      setHasJoint(false);
    }
    setCanRender(true);
  };

  useEffect(() => {
    if (Utils.isObjectEmpty(cardInfo)) {
      let templateId = cardInfo.templateId;
      Utils.getTemplateDetails(templateId).then(templateSuccess, fail);
    } else {
      templateSuccess({
        data: cardInfo.templateInfo,
      });
    }
  }, [cardInfo]);

  return (
    <>
      {canRender && (
        <div className="indi-qrcode-wrapper indi-signature-item">
          <div className="indi-qrcode-box row">
            <div className="indi-signature-title col-sm-10">
              {salutation}
              {cardInfo?.userFieldInfo?.firstName}{" "}
              {cardInfo?.userFieldInfo?.lastName}
            </div>
            <div className={classNames}>
              <div
                className="indi-logo-image qqq"
                style={{
                  backgroundColor: `${imgBackgroundColor}`,
                  borderColor: `${imgBackgroundColor}`,
                }}
              >
                <img
                  src={templateInfo.logoImage}
                  alt="card"
                  style={{
                    backgroundColor: `${imgBackgroundColor}`,
                  }}
                ></img>
              </div>

              {hasJoint && (
                <div
                  className={logoImageClasses}
                  style={{
                    backgroundColor: `${jointImgBackgroundColor}`,
                    borderColor: `${jointImgBackgroundColor}`,
                  }}
                >
                  <img
                    src={templateInfo.jointLogoImage}
                    alt="card"
                    style={{
                      backgroundColor: `${jointImgBackgroundColor}`,
                    }}
                  ></img>
                </div>
              )}
            </div>

            <div className="indi-signature-template">
              <div className="indi-qrcode-box-info-col">
                <div className="indi-qrcode-box-logo"></div>
                <div className="indi-qrcode-box-personal-info">
                  <div className="indi-qrcode-box-personal-name d-none">
                    {cardInfo?.userFieldInfo?.firstName}{" "}
                    {cardInfo?.userFieldInfo?.lastName}
                  </div>
                  <div className="indi-qrcode-box-personal-desgination">
                    {cardInfo?.userFieldInfo?.title}
                  </div>
                  {cardInfo?.userFieldInfo?.specialText &&(
                    <div className="indi-qrcode-box-personal-special-text">
                    {cardInfo?.userFieldInfo?.specialText}
                    </div>
                  )}
                </div>
                <div className="indi-qrcode-box-contacts">
                  {mobiles?.map((mobile, index) => (
                    <div className="indi-qrcode-box-mobile" key={index}>
                      <div className="indi-ellipsis">
                        <span className={floatClassNames}>
                          <span className="indi-card-field-item-img indi-card-field-item-mobile">
                            <img src={mobileImg} alt="" />
                          </span>
                        </span>
                        {mobile}
                      </div>
                    </div>
                  ))}

                  <div className="indi-qrcode-box-email">
                    <div className="indi-ellipsis">
                      <span className={floatClassNames}>
                        <span
                          className="indi-card-field-item-img indi-card-field-item-email"
                          // style={{
                          //   backgroundImage: `url(${emailImg})`,
                          // }}
                        >
                          <img src={emailImg} alt="" />
                        </span>
                      </span>
                      {cardInfo?.userFieldInfo?.email || userData.email}
                    </div>
                  </div>
                  {showAddress && (
                    <div className="indi-qrcode-box-address">
                      <div className="">
                        <span className={floatClassNames}>
                          <span
                            className="indi-card-field-item-img indi-card-field-item-address"
                            // style={{
                            //   backgroundImage: `url(${emailImg})`,
                            // }}
                          >
                            <img src={addressImg} alt="" />
                          </span>
                        </span>
                        <span>{fullAddress}</span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="indi-qrcode-box-save-contact">
                  <Button
                    style={{
                      backgroundColor: `${imgBackgroundColor}`,
                      borderColor: `${imgBackgroundColor}`,
                    }}
                    variant="primary"
                  >
                    {cardInfo?.labelInfo?.SAVE_CONTACT || "SAVE CONTACT"}
                  </Button>
                </div>
                <div className="indi-wrap-overflow-icons">
                  {cardInfo?.userLinkedBadges?.map((badge, index) => (
                    <React.Fragment key={index}>
                      {badge?.badgeUID !== "address" &&
                        badge?.badgeUID !== "phone" &&
                        badge?.badgeUID !== "email" && (
                          <img
                            className="indi-mini-card-badge-icon"
                            src={badge.iconImage}
                            alt=""
                          />
                        )}

                      {badge?.badgeUID === "address" && !showAddress && (
                        <img
                          className="indi-mini-card-badge-icon"
                          src={badge.iconImage}
                          alt=""
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <div className="indi-qrcode-box-img-col">
                {/* <div
                  className="indi-qrcode-bg d-none"
                  style={{
                    background: `url(${templateInfo.backgroundImage})`,
                  }}
                >
                  <div
                    className="indi-qrcode-logo"
                    style={{
                      backgroundImage: `url(${templateInfo.logoImage})`,
                    }}
                  ></div>
                </div> */}
                <div className="indi-qrcode-box-codes">
                  <div className="indi-qrcode-box-qrcode">
                    <img
                      className="indi-qrcode-qrcode"
                      src={qrCode}
                      alt="qrcode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QRCode;
